<p>
    Developed during Ludum Dare 37, Sam tells the story of pixel guy named Sam.
    It is story based 2D platformer where your decisions matter.
</p>

<p>
    Sam was an absolutely massive undertaking for the allotted 72 hours of the
    Jam. I didn't sleep much. It was the first game I made where I did all the
    art. Despite some mechanical shortcomings, I'm still proud of the game's
    atmosphere.
</p>

<p>
    Sam scored second in the 'mood' category and was #32 overall. Unfortunately,
    the original Ludum Dare site was taken down, but the original entry is still
    available on
    <a
        href="https://web.archive.org/web/20201126172954/http://ludumdare.com/compo/ludum-dare-37/?action=preview&uid=125769"
        >Web Archive.</a
    >
</p>
